<header class="row mx-0 p-1">
  <div class="col-12 pl-3 col-sm-3 d-flex align-items-center justify-content-start">
    <img src="/assets/Images/logo_SolarTurbines.png" alt="Solar Turbines" class="sg-header-logo">
  </div>

  <div class="col-12 col-sm-6 d-flex align-items-center justify-content-center">
    <span class="mat-display-1 mb-0 sg-header">Solar Supplier Gateway</span>
  </div>
  <div class="col-12 col-sm-3 pr-0 d-flex align-items-center justify-content-end">
    <div class="row mx-0 w-100 justify-content-end">
      <div class="col-10 mr-1">
        <div class="d-flex justify-content-end">
          <i class="material-icons pt-2 pr-3 pointer-cursor" (click)="notificationShow()">notifications</i>
           <span class="sg-notification-circle" *ngIf="isNotificationAvailable"></span> 
          <i class="material-icons pt-2">person</i>
          <span class="sg-username pt-2">{{userFullName}}</span>
        </div>
      </div>
      <div class="col-1 pr-1 d-flex justify-content-end">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon class="ds-setting">settings</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <div class="row mx-0 mt-2 sg-setting-menu-container">
            <div class="col-12 sg-role-header mb-3 mt-1 text-center">
              Role: {{userRole}}
            </div>
          </div>
          <mat-divider></mat-divider>
          <div class="sg-theme-title"><span>Theme</span></div>
          <div class="col-12 px-0">
            <div class="row mb-1 sg-setting-theme-hover py-2 mx-0">
              <div class="col-2 offset-1 nopadding">
                <span class="material-icons-outlined sg-icon" *ngIf="help_icon">check</span>
              </div>
              <div class="col-8 nopadding theme-hover">
                <span class="sg-settings-theming cursor" (click)="onDarkThemeClick()">Dark Theme</span>
              </div>

            </div>
            <div class="row sg-setting-theme-hover py-2 mx-0">
              <div class="col-2 offset-1 nopadding">
                <span class="material-icons-outlined sg-icon" *ngIf="select_icon">check</span>
              </div>
              <div class="col-8 nopadding theme-hover">
                <span class="sg-settings-theming cursor" (click)="onLightThemeClick()">Light Theme</span>
              </div>
            </div>
            <div class="row py-0 mx-0 sg-logout-section sg-setting-theme-hover">
              <button mat-menu-item (click)="completeLogout()">
                <div class="col-2 mr-2 px-0 material-icons-outlined">logout
                </div>
                <span class="col-8 p-0 cursor sg-logout-size">
                  Logout
                </span>
              </button>
            </div>
          </div>
          <mat-divider></mat-divider>

        </mat-menu>
      </div>
    </div>
  </div>
</header>

<div>
<mat-drawer-container class="notification-container sg-drawer-container" *ngIf="notificationTag">
  <mat-drawer class="notificationTag sg-drawer" mode="side" opened="true">
    <div class="row mx-0 w-100 h-100">
      <app-notificationbanner class="h-100 w-100" (notificationCountVal)='notificationCountVal($event)' (closeNotification)='closeNotification($event)'></app-notificationbanner>
    </div>
  </mat-drawer>
</mat-drawer-container>
</div>
<div class="row m-0">
  <div class="sg-environment-warning" 
      id="sg-environment-warning"
    *ngIf="environmentName && environmentName !== 'PRODUCTION'">
    Warning: This is {{environmentName}} environment
  </div>
</div>